// extracted by mini-css-extract-plugin
export default {"comment-indicator":"DiffLineTableCellParts-module__comment-indicator--eI0hb","in-progress-comment-indicator":"DiffLineTableCellParts-module__in-progress-comment-indicator--hx3m3"};